import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=6116c140&scoped=true&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=6116c140&lang=less&scoped=true&"
import style1 from "./order-detail.vue?vue&type=style&index=1&id=6116c140&lang=less&scoped=true&"
import style2 from "./order-detail.vue?vue&type=style&index=2&id=6116c140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116c140",
  null
  
)

export default component.exports